import objectToFormData from "object-to-formdata";

export const convertDataToFormDataFormat = (data) => {
  if (isUndefined(data) || isNull(data)) {
    return null;
  }
  if (isFile(data) || isBlob(data)) {
    data = { file: data };
  }

  return objectToFormData(data);
};

export const isFileOrContainsFile = (value) => {
  if (isUndefined(value) || isNull(value)) {
    return false;
  }
  if (isFile(value) || isBlob(value)) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.some(isFileOrContainsFile);
  }
  if (value === Object(value)) {
    return isFileOrContainsFile(Object.values(value));
  }
  return false;
};

export const undefinedAsTrue = (value) => (value === undefined ? true : value);

// The helper functions below were copied from: https://github.com/therealparmesh/object-to-formdata/blob/main/src/index.js
// these are the same functions that 'objectToFormData' uses to  convert the data.
const isUndefined = (value) => value === undefined;

const isNull = (value) => value === null;

const isBlob = (value) => value && typeof value.size === "number" && typeof value.type === "string" && typeof value.slice === "function";

export const isFile = (value) =>
  isBlob(value) && typeof value.name === "string" && (typeof value.lastModifiedDate === "object" || typeof value.lastModified === "number");
